import { useContext } from 'react';

import { TimeseriesFilteredDataContext } from '../context/TimeseriesFilteredData.context.js';

export const useTimeseriesFilteredData = () =>
  useContext(TimeseriesFilteredDataContext);
